{
    "DAYS": "Tage",
    "HOURS": "Stunden",
    "MINUTES": "Min",
    "SECONDS": "Sek",
    "STARTING_SOON": "Beginnt bald...",
    "DEFAULT_ERROR": "Wiedergabefehler",
    "DEFAULT_ERROR_DESCRIPTION": "Das Video kann nicht abgespielt werden. Bitte versuchen Sie es später erneut.",
    "API_ERROR": "Fehler beim Abrufen der Videoinformationen",
    "API_ERROR_DESCRIPTION": "Fehler beim Abrufen der Videodetails. Überprüfen Sie Ihre videoId und Internetverbindung und versuchen Sie es erneut.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorisierung",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "Sie haben keine Berechtigung, dieses Video abzuspielen.",
    "ERROR_CODE_GEO_BLOCKED": "Geoblocking-Beschränkung",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Entschuldigung, dieses Video ist in Ihrer Region aufgrund von Geoblocking-Beschränkungen nicht verfügbar.",
    "ERROR_CODE_NOT_ENTITLED": "Nicht berechtigt",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Entschuldigung, Sie sind nicht berechtigt, dieses Video abzuspielen.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOCKIERT",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Dieses Video ist aufgrund der Verwendung eines VPN nicht verfügbar.",
    "ERROR_CODE_IP_CHANGED": "Netzwerk gewechselt",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "Sie haben unerwartet das Netzwerk gewechselt. Bitte versuchen Sie es erneut.",
    "ERROR_CODE_VPN_DETECTED": "VPN erkannt",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "Wir haben ein VPN erkannt. Bitte deaktivieren Sie es und versuchen Sie es erneut.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Anonymer Proxy erkannt",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "Wir haben einen anonymen Proxy oder Server erkannt. Bitte deaktivieren Sie ihn und versuchen Sie es erneut.",
    "CONCURRENCY_KICKED": "Gerätelimit erreicht",
    "CONCURRENCY_KICKED_DESCRIPTION": "Sie haben die maximale Anzahl an Geräten überschritten, die dieses Video gleichzeitig ansehen dürfen.",
    "CONCURRENCY_CONNECTION_FAILED": "Verbindungsfehler",
    "CONCURRENCY_CONNECTION_FAILED_DESCRIPTION": "Verbindung konnte nicht hergestellt werden. Bitte versuchen Sie es erneut."
}
